import PropTypes from "prop-types";
import classNames from "classnames";

const IconParalympicsBroadcaster = ({ className }) => {
    const classes = classNames("paralympicsBroadcasterIcon", className);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="74"
            height="32"
            viewBox="0 0 1677.17 872.1"
            className={classes}
            role="presentation"
        >
            <g fill="#FFFFFF" fillRule="nonzero">
                <path
                    d="M57,865.5a29.27,29.27,0,0,1-12.5,5.8,45.78,45.78,0,0,1-8.3.8,33.67,33.67,0,0,1-12.9-2.5A32.15,32.15,0,0,1,13,862.7a33.57,33.57,0,0,1-6.8-10.3,32.24,32.24,0,0,1-2.4-12.7v-.2a34.9,34.9,0,0,1,2.4-12.7A32.42,32.42,0,0,1,13,816.5a30.78,30.78,0,0,1,10.4-7,35.79,35.79,0,0,1,13.3-2.6,44.32,44.32,0,0,1,8.1.7,29.65,29.65,0,0,1,6.6,2,25,25,0,0,1,5.5,3.1,35.52,35.52,0,0,1,4.7,4l-8.8,10.1a34.72,34.72,0,0,0-7.5-5.2,19.63,19.63,0,0,0-8.6-1.9,16.88,16.88,0,0,0-13.1,5.8,20.7,20.7,0,0,0-3.8,6.2,21.78,21.78,0,0,0-1.4,7.6v.2a20.57,20.57,0,0,0,1.4,7.7,20.11,20.11,0,0,0,3.7,6.3,16.94,16.94,0,0,0,13.2,5.8,19,19,0,0,0,9.1-2,36,36,0,0,0,7.4-5.4l8.8,8.9A44.76,44.76,0,0,1,57,865.5Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M120,871l-5.8-14.1H87.6L81.9,871H67.7l27-63.5h12.8l27,63.5Zm-19-46.8-8.4,20.4h16.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M188.4,871l-30.5-40v40H144.2V808H157l29.5,38.8V808h13.7v63Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M262.2,871l-5.8-14.1H229.8L224,871H209.9l27-63.5h12.8l27,63.5Zm-19-46.8-8.4,20.4h16.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M342.1,851.9a28.93,28.93,0,0,1-6.9,10,32.84,32.84,0,0,1-10.6,6.7,36.72,36.72,0,0,1-13.5,2.5H286.5v-63H311a36.63,36.63,0,0,1,13.5,2.4,31.54,31.54,0,0,1,10.6,6.6A29.5,29.5,0,0,1,342,827a30.8,30.8,0,0,1,2.4,12.4v.2A30.88,30.88,0,0,1,342.1,851.9ZM330,839.5a22.77,22.77,0,0,0-1.4-7.7,18.27,18.27,0,0,0-3.9-6,17.29,17.29,0,0,0-6-3.9,20.57,20.57,0,0,0-7.7-1.4H300.3v38H311a22.25,22.25,0,0,0,7.7-1.3,16,16,0,0,0,6-3.9,17.86,17.86,0,0,0,3.9-5.9,19.87,19.87,0,0,0,1.4-7.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M403.7,871,398,856.8H371.3L365.5,871H351.4l27-63.5h12.8l27,63.5Zm-19.1-46.8-8.4,20.4H393Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M431.9,822.4h-5.5V808h14.5v12.2c0,5.9-1.4,10.2-4.3,12.8s-7,3.9-12.3,4l-1.2-5.7C429.4,830.6,432.4,827.6,431.9,822.4Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M497.5,860.7a16.68,16.68,0,0,1-4.7,6.1,22.13,22.13,0,0,1-7.3,3.8,32.64,32.64,0,0,1-9.3,1.3,40.87,40.87,0,0,1-14.2-2.5,38.61,38.61,0,0,1-12.6-7.6l8.2-9.8a43.08,43.08,0,0,0,8.9,5.6,24.23,24.23,0,0,0,10,2.1,12.11,12.11,0,0,0,6.7-1.6,5.12,5.12,0,0,0,2.4-4.4v-.2a6.87,6.87,0,0,0-.5-2.4,4.36,4.36,0,0,0-1.9-1.9,23.22,23.22,0,0,0-3.9-1.8c-1.7-.6-3.8-1.2-6.5-1.9-2.9-.7-5.8-1.6-8.7-2.6a21.24,21.24,0,0,1-6.6-3.6,14.56,14.56,0,0,1-4.2-5.3,17.52,17.52,0,0,1-1.5-7.8V826a17.67,17.67,0,0,1,6.1-13.8,22.39,22.39,0,0,1,6.9-3.9,27,27,0,0,1,8.9-1.3,39.33,39.33,0,0,1,12.7,2.1,38.49,38.49,0,0,1,10.7,5.9l-7.2,10.5a44.44,44.44,0,0,0-8.3-4.5,22.58,22.58,0,0,0-8.1-1.7c-2.7,0-4.7.5-6.1,1.6a4.74,4.74,0,0,0-2,3.9v.2a6.6,6.6,0,0,0,.6,2.7,5.06,5.06,0,0,0,2.1,2,19.44,19.44,0,0,0,4.2,1.7c1.8.5,4,1.2,6.7,1.9a65,65,0,0,1,8.5,2.8,22.54,22.54,0,0,1,6.3,3.8,14.27,14.27,0,0,1,3.9,5.2,17.52,17.52,0,0,1,1.3,7.1v.2A16.15,16.15,0,0,1,497.5,860.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M586.1,839.5a18.53,18.53,0,0,1-5.5,6.9,25,25,0,0,1-8.1,4.2,33.37,33.37,0,0,1-9.9,1.4H552.1v19H538.2V808H564a28.88,28.88,0,0,1,10.1,1.6,22.52,22.52,0,0,1,7.6,4.5,19.52,19.52,0,0,1,4.8,6.9,24.29,24.29,0,0,1,1.7,8.9v.2A22.2,22.2,0,0,1,586.1,839.5Zm-12-9.5c0-3.1-1-5.5-3-7.1s-4.7-2.4-8.2-2.4H552.2v19.3h11c3.5,0,6.2-.9,8.1-2.8a9.06,9.06,0,0,0,2.9-6.8Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M645.3,871l-5.8-14.1H612.9L607.1,871H593l27-63.5h12.8l27,63.5Zm-19.1-46.8-8.4,20.4h16.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M707.7,871l-13.5-20.2H683.3V871H669.4V808h28.8c7.5,0,13.3,1.8,17.5,5.5s6.3,8.8,6.3,15.3v.2c0,5.1-1.2,9.3-3.7,12.5a21.85,21.85,0,0,1-9.8,7.1l15.4,22.5H707.7Zm.3-41.5a8.34,8.34,0,0,0-2.9-6.8c-1.9-1.5-4.6-2.2-8-2.2H683.3v18.1h14c3.4,0,6-.8,7.9-2.4a8.69,8.69,0,0,0,2.8-6.5Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M781.4,871l-5.8-14.1H749L743.3,871H729.2l27-63.5H769L796,871Zm-19-46.8L754,844.6h16.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M805.6,871V808h13.9v50.5h31.4V871Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M892.9,845.8V871H879V846.1L854.9,808h16.2l15,25.3L901.4,808h15.8Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M975.1,871V829.8l-17.7,26.9H957l-17.5-26.6V871H925.8V808h14.9l16.6,26.6L973.9,808h14.9v63Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1051.8,839.5a19.32,19.32,0,0,1-5.4,6.9,25,25,0,0,1-8.1,4.2,33.57,33.57,0,0,1-10,1.4h-10.5v19h-13.9V808h25.7a28.88,28.88,0,0,1,10.1,1.6,22.52,22.52,0,0,1,7.6,4.5,19.52,19.52,0,0,1,4.8,6.9,24.29,24.29,0,0,1,1.7,8.9v.2A23.69,23.69,0,0,1,1051.8,839.5Zm-12.1-9.5c0-3.1-1-5.5-3-7.1s-4.7-2.4-8.2-2.4h-10.7v19.3h11c3.5,0,6.2-.9,8.1-2.8a9.06,9.06,0,0,0,2.9-6.8Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1064.7,871V808h13.9v63Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1144.6,865.5a29.27,29.27,0,0,1-12.5,5.8,45.78,45.78,0,0,1-8.3.8,33.67,33.67,0,0,1-12.9-2.5,32.15,32.15,0,0,1-10.3-6.9,33.57,33.57,0,0,1-6.8-10.3,32.24,32.24,0,0,1-2.4-12.7v-.2a34.9,34.9,0,0,1,2.4-12.7,32.42,32.42,0,0,1,6.8-10.3,31.38,31.38,0,0,1,10.3-7,35.79,35.79,0,0,1,13.3-2.6,44.32,44.32,0,0,1,8.1.7,29.65,29.65,0,0,1,6.6,2,25,25,0,0,1,5.5,3.1,35.52,35.52,0,0,1,4.7,4l-8.8,10.2a34.72,34.72,0,0,0-7.5-5.2,19.63,19.63,0,0,0-8.6-1.9,16.88,16.88,0,0,0-13.1,5.8,20.7,20.7,0,0,0-3.8,6.2,19.63,19.63,0,0,0-1.3,7.6v.2a22.65,22.65,0,0,0,1.3,7.7,20.11,20.11,0,0,0,3.7,6.3,16.94,16.94,0,0,0,13.2,5.8,19,19,0,0,0,9.1-2,36,36,0,0,0,7.4-5.4l8.8,8.9A36,36,0,0,1,1144.6,865.5Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1231.9,871l-30.5-40v40h-13.7V808h12.8l29.5,38.8V808h13.7v63Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1258.8,871V808h47.4v12.3h-33.8v12.8h29.7v12.3h-29.7v13.2h34.2V871Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1347.6,820.7V871h-13.9V820.7h-19.2V808h52.2v12.8Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1446.6,871.4h-12.1l-14.2-41.2-14.2,41.2H1394L1372.5,808h14.8l13,42.7,14.1-42.8h11.9l14.1,42.8,13.1-42.7H1468Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1540,852.1a32.61,32.61,0,0,1-17.6,17.4,36.75,36.75,0,0,1-26.9,0,35.23,35.23,0,0,1-10.6-6.9,30.11,30.11,0,0,1-6.9-10.3,32.19,32.19,0,0,1-2.5-12.6v-.2a33,33,0,0,1,2.5-12.7,32,32,0,0,1,17.6-17.4,36.43,36.43,0,0,1,13.5-2.6,32.35,32.35,0,0,1,13.4,2.6,35.23,35.23,0,0,1,10.6,6.9,30.11,30.11,0,0,1,6.9,10.3,32.33,32.33,0,0,1,2.5,12.7v.2A30.5,30.5,0,0,1,1540,852.1Zm-12-12.6a22.77,22.77,0,0,0-1.4-7.7,19.24,19.24,0,0,0-10-10.6,18.33,18.33,0,0,0-7.7-1.6,20.31,20.31,0,0,0-7.7,1.5,16.73,16.73,0,0,0-5.9,4.2,19.13,19.13,0,0,0-3.9,6.2,21.78,21.78,0,0,0-1.4,7.6v.2a22.77,22.77,0,0,0,1.4,7.7,19.24,19.24,0,0,0,10,10.6,18.33,18.33,0,0,0,7.7,1.6,20.69,20.69,0,0,0,7.7-1.5,18.08,18.08,0,0,0,6-4.2,19.58,19.58,0,0,0,3.9-6.3,21.78,21.78,0,0,0,1.4-7.6Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1593.1,871l-13.5-20.2h-10.9V871h-13.9V808h28.8c7.5,0,13.3,1.8,17.5,5.5s6.3,8.8,6.3,15.3v.2c0,5.1-1.2,9.3-3.7,12.5a21.85,21.85,0,0,1-9.8,7.1l15.4,22.5h-16.2Zm.3-41.5a8.34,8.34,0,0,0-2.9-6.8c-1.9-1.6-4.6-2.2-8-2.2h-13.8v18.1h14c3.4,0,6-.8,7.9-2.4a8.69,8.69,0,0,0,2.8-6.5Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1660.6,871l-19.5-26.8-7.3,7.6V871H1620V808h13.9v27.5l25.5-27.5h16.7l-25.7,26.7,26.8,36.3Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1181,535.6c-3.3,1.1-53.6-.4-44.1-42.4s88.3-64.3,101.9-57.7c-19.9,7.8-59.8,11.5-78.8,53.3-18.8,41.4,20.7,46.2,21,46.8"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1256.1,565.8c-1.3,3.2-34.7,40.8-60.9,6.6s7.5-109,21.4-115.1c-6.9,20.2-29.6,53.2-9.8,94.7,19.5,40.8,48.6,13.6,49.3,13.8"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1326.1,507.6c2.8,2.1,30.5,44.1-9.4,60.5s-103.3-35.4-105.7-50.4c17.7,11.8,43.7,42.4,88.9,34,44.6-8.2,25.8-43.4,26.2-44.1"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1509.4,287c-99.6,10.3-75.6,0-86-42.9-5.8.6-56.8,59-71.2,27.7,4.5-40.3,6.4-47.9,10.5-88.1-13.7,6.6-25,20.6-47.3,24.8a13.92,13.92,0,0,1-6.4-.4c-26.6-17.6-24.5-63.4-34.4-132.9-41.6,60.6-49.1,95.4-50.2,109.6-1.5,6.2-12.6,65.9,62,184.3,30.4,48.2,6.2,98.3,2.5,104.7,11.1-10.9,77.4-65.9,72.5-147.1,17.3,48.2,15.2,100.2-12.4,143.7-8.9,14.1-4.6,7.6-13.2,17.9,30.3-9.6,107.1,3.2,122.8-3.1-9.2-12.2-54.9-20.7-28-38.8,38.8-35.9,4-5.9,43.5-39.7-.2-1.1,53.1-36.6,53-37.3-46.6-10.4-20.2-45.6-17.7-82.4"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1233.8,326.9c6.1,6.6-65.5-98.3-30.9-158.7,0,0-94.4,83.9,1.7,136.7.1.1,19.8,11.9,29.2,22"
                    transform="translate(-0.03)"
                />
                <path
                    d="M1297.9,678.6c-185.6,0-336.6-151-336.6-336.6S1112.3,5.4,1297.9,5.4s336.6,151,336.6,336.6-151,336.6-336.6,336.6m0-643.9c-169.5,0-307.3,137.9-307.3,307.3s137.9,307.3,307.3,307.3S1605.2,511.5,1605.2,342,1467.3,34.7,1297.9,34.7"
                    transform="translate(-0.03)"
                />
                <rect x="814.77" width="4" height="684" />
                <path
                    d="M336.6,462.3A120.25,120.25,0,1,0,216.3,342.1c-.1,66.3,53.8,120.2,120.3,120.2Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M197.7,462.3a120.31,120.31,0,0,1-2.2-240.6h2.2Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M475.5,595V480.9H589.7A114.12,114.12,0,0,1,475.6,595Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M197.7,88.9V203.2H83.3A114.42,114.42,0,0,1,197.7,88.9"
                    transform="translate(-0.03)"
                />
                <path
                    d="M197.7,595.1V480.9H83.4A114.16,114.16,0,0,0,197.6,595.1Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M614.5,445.4l-.1-206.7a120.32,120.32,0,0,1,.1,206.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M233.2,64.1H439.9a120.29,120.29,0,0,0-206.7,0Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M438.4,619.8H231.7a120.16,120.16,0,0,0,206.7,0Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M456.8,480.9a120.3,120.3,0,0,1-240.6,0Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M475.5,462.3a120.31,120.31,0,0,0,2.2-240.6h-2.2Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M456.8,203.3a120.3,120.3,0,1,0-240.6,0Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M58.7,445.4l.1-206.7a120.38,120.38,0,0,0-.1,206.7Z"
                    transform="translate(-0.03)"
                />
                <path
                    d="M589.7,203.2l-114.2-.1V89A114.16,114.16,0,0,1,589.7,203.2"
                    transform="translate(-0.03)"
                />
            </g>
        </svg>
    );
};

IconParalympicsBroadcaster.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconParalympicsBroadcaster;
